import { render, staticRenderFns } from "./TableRestored.vue?vue&type=template&id=e54c8d72&scoped=true"
import script from "./TableRestored.vue?vue&type=script&lang=js"
export * from "./TableRestored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54c8d72",
  null
  
)

export default component.exports